"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamsSlugs = exports.Teams = void 0;
exports.Teams = {
    // Admin Platform
    /**
     *  **Admin Platform**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3597631576/Admin+Platform)
     */
    AP: 'AP',
    // Platform cluster
    /**
     * @deprecated
     *  **Web Platform**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/2151841878/Web+Platform)
     */
    WP: 'WP',
    /**
     * @deprecated
     *  **Microsites Platform**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3797745757/Microsites+Platform)
     */
    MICROSIT: 'MICROSIT',
    /**
     *  **Experimentation Platform**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/1884291235/Experimentation+platform)
     */
    EP: 'EP',
    // Customer cluster
    /**
     * @deprecated
     *  **Shopping Experience**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/1933639693/Shopping+Experience)
     */
    SE: 'SE',
    /**
     *  @deprecated
     *  **Checkout**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/1578959147/Checkout)
     */
    CK: 'CK',
    /**
     *  @deprecated
     *  **Customer Solutions**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/886243428/Customer+Solutions)
     */
    CS: 'CS',
    /**
     *  @deprecated
     *
     *  Use WEBX instead
     *
     *  **Customer Core Experience**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/2508358630/Customer+Core+Experience+CCE)
     */
    CCE: 'CCE',
    /**
     * @deprecated
     * Use WEB instead
     *
     * **Web Experience**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/4838654000/Web+Experience+WebX)
     */
    WEBX: 'WEBX',
    /**
     *  **Tracking and Reviews Experience**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/886243428/Tracking+and+Reviews+Experience)
     */
    TREX: 'TREX',
    /**
     *  @deprecated
     *  **Product and Cart**
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/2972812719/Product+and+Cart)
     */
    PAC: 'PAC',
    /**
     *  @deprecated
     *  **Mobile Store Front**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/17825860/Mobile+Storefront)
     */
    MSF: 'MSF',
    // Contact cluster
    /**
     * @deprecated
     *  **Contact Tools**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/928153601/Contact+Tools)
     */
    CT: 'CT',
    /**
     *  @deprecated
     *  **Agent Efficiency**
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/1253016067/Agent+Efficiency)
     */
    AEF: 'AEF',
    /**
     *  @deprecated
     *
     *  Use CC instead
     *  **Logistics Contact**
     *  Team in charge of the migration of Contact Scope to DH.
     */
    LC: 'LC',
    /**
     *  **Core Contact**
     *  Team in charge of Core Contact the migration of Contact Scope to DH.
     *
     * [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/4586930202/Core+-+Contact)
     */
    CC: 'CC',
    /**
     *  @deprecated
     *  Team no longer exists
     *  **Refund and Compensations**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/2976219668/Refunds+and+Compensations)
     */
    RC: 'RC',
    /**
     *  @deprecated
     *
     * Team no longer exists
     * **Chat Experience**
     *
     * [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3204284502/Chat+Experience)
     */
    CE: 'CE',
    // Growth cluster
    /**
     * @deprecated
     *  **Web Store Front**
     *
     *   Deprecated in favor of MSF
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/17825860/Mobile+Storefront)
     */
    WSF: 'WSF',
    /**
     * @deprecated
     *  **Web Acquisition Landing Experience**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/1912406229/)
     */
    WALE: 'WALE',
    /**
     * @deprecated
     *  **Web Acquisition Fundamentals**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3262054477/)
     */
    WAF: 'WAF',
    /**
     *  **Loyalty**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/1911816477/Team%3A+Loyalty)
     */
    LOY: 'LOY',
    /**
     *  **Promotions**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/1429996644/Team+Promos)
     */
    PRO: 'PRO',
    /**
     *  **Marketing Technologies**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/2411758214/Team+Mar+Tech)
     */
    MAR: 'MAR',
    /**
     * @deprecated
     *  **Web Acquisition Store Page**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3326116139/Team+Web+Acquisition+Store+Page)
     */
    WASP: 'WASP',
    /**
     *  **Vouchers**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3291316266/Team%3A+Vouchers)
     */
    VOUCH: 'VOUCH',
    // Content and partners cluster
    /**
     *  **Content Management**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/1563852817/Content+Management)
     */
    CM: 'CM',
    /**
     *  **Product Information Management**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/2376598307/PIM)
     */
    PIM: 'PIM',
    /**
     *  **Product Enrichment**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3296526578/Product+Enrichment)
     */
    PE: 'PE',
    /**
     *  **Content Search**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/2276820252/Content+Search)
     */
    CSE: 'CSE',
    /**
     *  **Platform Testing Team**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3214836848/Platform+Testing+Team)
     */
    PTT: 'PTT',
    /**
     *  **Operational Pricing**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/800882917/Team%3A+Operational+Pricing)
     */
    OPR: 'OPR',
    /**
     *  @deprecated
     *
     *  Use POT instead
     */
    PAR: 'PAR',
    /**
     *  @deprecated
     *  **Partner Management**
     *
     *  Use PLC instead
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/2411759881/Partner+Management)
     */
    PMT: 'PMT',
    /**
     *  **Partner Life Cycle**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/1607795199/Partner+Life+Cycle+PLC)
     */
    PLC: 'PLC',
    /**
     * @deprecated
     *  **Partner Intelligence**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3765829804/Partner+Intelligence)
     */
    PIT: 'PIT',
    /**
     *  **Partner Performance**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3765829804/Partner+Performance+PP)
     */
    PP: 'PP',
    /**
     *  **Search and Discovery**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/92078134)
     */
    SD: 'SD',
    /**
     *  @deprecated
     *  **Partner Account and Identity**
     *
     *  Use PLC instead
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/1607795199/Partner+Accounts+Identity)
     */
    PAI: 'PAI',
    /**
     * @deprecated
     *  **Glover experience**
     *
     */
    GX: 'GX',
    /**
     *  **Finance Activation**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/2509308643/Fintech+Cluster)
     */
    FA: 'FA',
    // Fintech cluster
    /**
     *  **Money Flow**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/2509308643/Fintech+Cluster)
     */
    MF: 'MF',
    /**
     *  **Payments and Fraud*
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/2509308643/Fintech+Cluster)
     */
    PAY: 'PAY',
    /**
     *  **Core Payments**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/2509308643/Fintech+Cluster)
     */
    RSK: 'RSK',
    /**
     *  **Risk and Identity**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/2509308643/Fintech+Cluster)
     */
    PX: 'PX',
    /**
     *  **Invoicing**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/2509308643/Fintech+Cluster)
     */
    INV: 'INV',
    // Logistics cluster
    /**
     *  **Delivery Flow**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/1039762437/Delivery+Flow)
     */
    DF: 'DF',
    /**
     *  **Delivery Management - Logistics as a Service**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3689971767/Delivery+Management+Team)
     */
    LDM: 'LDM',
    /**
     * @deprecated
     *  **Last Mile - Logistics as a Service**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/1752367219/Last+Mile+Team)
     */
    B2BL: 'B2BL',
    /**
     *  **eCommerce Management - Logistics as a Service**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/2935162929/eCommerce+Management+Team)
     */
    ELGEI: 'ELGEI',
    /**
     *  **Last Mile - Logistics as a Service merged team **
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3689971767/Delivery+Management+Team+Merged+with+eCommerceManagement+Team+-+New+Team+LaaS)
     */
    LAAS: 'LAAS',
    /**
     * @deprecated
     *  **Warehouse Operations- Logistics as a Service**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3344990233/Warehouse+Operations+Team)
     */
    WHOPS: 'WHOPS',
    /**
     *  **Forecasting**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/1310884277/Forecasting+Team)
     */
    DSFC: 'DSFC',
    /**
     *  **Dispatching**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3100412143)
     */
    DP: 'DP',
    /**
     *  **Supply and Demand**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3100412143/Supply+Demand+Balance+team)
     */
    SDB: 'SDB',
    /**
     *  **Partner Orders**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/2469330945/Partner+Orders)
     */
    POT: 'POT',
    /**
     *  **Partner Readiness**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/4141121875/Partner+Readiness+Team)
     */
    PRT: 'PRT',
    /**
     *  **Glovo Maps**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3531800577/GlovoMaps+Team)
     */
    LG: 'LG',
    /**
     *  **Scheduling**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3469247906/Scheduling+Team)
     */
    LGSC: 'LGSC',
    /**
     *  **Retail**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3499294854/Retail)
     */
    RET: 'RET',
    /**
     *  **Partner Solutions**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3565748665/Partner+Solutions)
     */
    PAS: 'PAS',
    // Courier Cluster
    /**
     *  **Courier 3PLs and innovation**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3291185161/Courier+3PLs+and+Innovation)
     */
    C3PLS: '3pl-innovation',
    /**
     *  **Courier Fraud & Cash**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3291185161/Courier+3PLs+and+Innovation)
     */
    CFC: 'CFC',
    /**
     *  **Courier Quality and Compliance**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3219095679/Courier+Quality+Compliance+CQC)
     */
    CQC: 'CQC',
    /**
     *  **Courier: Real-Time Automation**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/1253016685/Courier+Real-Time+Automation+RTA)
     */
    RTA: 'RTA',
    /**
     *  **Courier Rewards**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/1585972319/Courier+Rewards)
     */
    CR: 'CR',
    /**
     *  **Courier Growth**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3400761491/Courier+Growth)
     */
    CGW: 'CGW',
    /**
     *  **Courier Frontenders**
     *  Frontenders within the Courier cluster
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/2364473417/Courier+Teams)
     */
    CFE: 'CFE',
    /**
     *  **Courier Engagement Team**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/1283588234/Courier+EngagementZ)
     */
    CET: 'CET',
    /**
     *  **Croqueta**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3934781732/Croqueta+-+Who+we+are)
     */
    CQT: 'CQT',
    /**
     *  **Sonic**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/4486103126/Sonic+Team)
     */
    SONIC: 'SONIC',
    /**
     * @deprecated
     *  **Ads and Monetization**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3232336044/Ads+Monetization)
     */
    ADSMON: 'ADSMON',
    /**
     *  **Ads**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3232336044/Ads+Cluster)
     */
    ADS: 'ADS',
    /**
     *  @deprecated
     *  **Voice and Numbers**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3593797822/Voice+Numbers)
     */
    VN: 'VN',
    /**
     * LAAS frontend
     *
     * [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/3839524869/LaaS+Team) (fullstack team page)
     */
    LAASFE: 'laasfe',
    /**
     *   CM + PIM + PE teams frontenders **
     */
    CONTENT: 'CONTENT',
    /**
     *  **Web Experience**
     *
     *  [Tech Confluence](https://glovoapp.atlassian.net/wiki/spaces/TECH/pages/5247828365/Glovo+Web+Team)
     */
    WEB: 'WEB',
    // For components without clear ownership
    NoOwner: 'no-owner',
    // Fallback for cases when ownership is unknown
    Unknown: 'unknown',
};
exports.TeamsSlugs = {
    AP: 'admin-platform',
    WP: 'web-platform',
    MICROSIT: 'microsites-platform',
    EP: 'experimentation-platform',
    SE: 'shopping-experience',
    CK: 'checkout',
    CS: 'customer-solutions',
    CCE: 'customer-core-experience',
    TREX: 'tracking-and-reviews-experience',
    PAC: 'product-and-cart',
    MSF: 'mobile-store-front',
    CT: 'contact-tools',
    AEF: 'agent-efficiency',
    RC: 'refund-and-compensations',
    CE: 'chat-experience',
    WSF: 'web-store-front',
    WALE: 'web-acquisition-landing-experience',
    WAF: 'web-acquisition-fundamentals',
    LOY: 'loyalty',
    PRO: 'promotions',
    MAR: 'marketing-and-technologies',
    WASP: 'web-acquisition-store-page',
    VOUCH: 'vouchers',
    CM: 'content-management',
    PIM: 'product-information-management',
    PE: 'product-enrichment',
    CSE: 'content-search',
    PTT: 'platform-testing-team',
    OPR: 'operational-pricing',
    PAR: 'partner-orders',
    PMT: 'partner-management-team',
    PLC: 'partner-life-cycle',
    PIT: 'partner-intelligence-team',
    PP: 'partner-performance-team',
    SD: 'search-and-discovery',
    PAI: 'partner-account-and-identity',
    GX: 'glover-experience',
    FA: 'finance-activation',
    MF: 'money-flow',
    PAY: 'payments-and-fraud',
    RSK: 'core-payments',
    PX: 'risk-and-identity',
    INV: 'invoicing',
    DF: 'delivery-flow',
    LDM: 'delivery-management-team',
    B2BL: 'b2b-last-mile',
    ELGEI: 'ecommerce-management-team',
    LAAS: 'logistics-as-a-service',
    WHOPS: 'warehouse-operations',
    DSFC: 'forecasting-team',
    DP: 'dispatching',
    SDB: 'supply-and-demand-balance-da',
    POT: 'partner-orders',
    PRT: 'partner-readiness',
    LC: 'logistics-contact',
    CC: 'core-contact',
    LG: 'glovo-maps',
    LGSC: 'scheduling',
    RET: 'customer-retail',
    PAS: 'partner-solutions',
    C3PLS: 'courier-3pl',
    CFC: 'courier-fraud-cash',
    CQC: 'courier-quality-and-compliance',
    CQT: 'croqueta',
    SONIC: 'sonic',
    RTA: 'real-time-automation',
    CR: 'courier-rewards',
    CGW: 'courier-growth',
    CET: 'courier-engagement',
    CFE: 'courier-frontend',
    ADSMON: 'ads-monetization',
    ADS: 'ads',
    VN: 'contact-voice-numbers',
    LAASFE: 'mfc-laas-fe',
    CONTENT: 'content-group-fe',
    NoOwner: 'no-owner',
    Unknown: 'unknown',
    WEBX: 'web-experience',
    WEB: 'glovo-web-team',
};
//# sourceMappingURL=teams.js.map